module.exports = __webpack_public_path__ + "static/img/file_less.3e939761.png";